import type { PreloadConfig } from '@preload/graphql/getConfig.d'

export type FrontendPreloadConfig = PreloadConfig & {
    [K in keyof Omit<PreloadConfig, '__typename'>]?: PreloadConfig[K] & {
        queryPath?: string
        fetchConfig?: Record<string, unknown>
    }
}

export const preload: FrontendPreloadConfig = {
    menu: {
        queryPath:
            'framework/pylot/hooks/category/graphql/navigationMenuWithCMSBlocks.ts'
    }
}

export default preload
